// src/components/store/DealOfTheDay.tsx
"use client";

import DealSection from "./sections/deal";

interface DealOfTheDayProps {
  products?: any[];
  product?: any;
  subdomain?: string;
  variant?: string;
}

export default function DealOfTheDay(props: DealOfTheDayProps) {
  return <DealSection {...props} />;
}

export { DealOfTheDay as DealProductCard };
